<template>
  <div class="partner">
    <div class="bottom-wrap"></div>
    <div class="title">{{ $theme ? '合作伙伴' : 'PARTNERS' }}</div>
    <img class="line" src="@/assets/img/brand-honor/partner/line.png" alt="">
    <vue-seamless-scroll
        :data="[1,2,3, 4, 5]"
        class="top"
        :classOption="{
        step: 3,
        autoPlay: true,
        hoverStop: false,
        direction: direction
      }"
    >
      <div class="img-wrap">
        <img src="@/assets/img/brand-honor/partner/top.png" alt=""/>
      </div>
    </vue-seamless-scroll>
    <vue-seamless-scroll
        :data="[1,2,3, 4, 5]"
        class="bottom"
        :classOption="{
        step: 3,
        autoPlay: true,
        hoverStop: false,
        direction: direction
      }"
    >
      <div class="img-wrap">
        <img src="@/assets/img/brand-honor/partner/bottom.png" alt=""/>
      </div>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import VueSeamlessScroll from "vue-seamless-scroll";

export default {
  name: 'Partner',
  components: {
    VueSeamlessScroll
  },
  props: {
    direction: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {
  },
  destroyed() {
  },
}
</script>
<style lang="scss" scoped>
@import "Index";
</style>
